/**
 * API Configuration
 * 
 * Zentrale Konfiguration für alle API-Aufrufe.
 * Verwendet Environment-Variablen aus .env Dateien:
 * 
 * Development: .env
 * - REACT_APP_API_URL=http://localhost:5174/api
 * 
 * Production: .env.production
 * - REACT_APP_API_URL=https://frankenfloss.net/api
 * 
 * Build-Commands:
 * - npm start → verwendet .env
 * - npm run build → verwendet .env.production
 */

// API Base URL aus Environment-Variable (mit Fallback für Development)
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5174/api';
export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5174';

// Helper function to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    console.error('No token found in localStorage');
    throw new Error('Nicht authentifiziert. Bitte melden Sie sich erneut an.');
  }
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// Helper function for API calls with error handling
export const apiCall = async (endpoint: string, options: RequestInit = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        ...getAuthHeaders(),
        ...options.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`API call failed: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`API call to ${endpoint} failed:`, error);
    throw error;
  }
};

// Debug: Log current configuration (nur in Development)
if (process.env.NODE_ENV === 'development') {
  console.log('API Configuration:', {
    API_BASE_URL,
    BASE_URL,
    NODE_ENV: process.env.NODE_ENV,
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  });
}
